import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter as Router } from 'connected-react-router';
import { history } from '../redux'
import { ToastContainer } from 'react-toastify';

import { userIsAuthenticated, userIsNotAuthenticated } from '../hoc/authentication';
import { CommonUtils, path } from '../utils'
import Home from '../routes/Home';
import { CustomToastCloseButton } from '../components/CustomToast';
import CreateAccount from './Register/CreateAccount';
import './App.scss';

import HeaderRegister from "./Register/Header/Header";
import FooterRegister from "./Register/Footer/Footer";
import CustomScrollbars from "../components/CustomScrollbars";
import Banner from './Register/Banner/Banner';
import ActiveEmail from './Register/ActiveEmail';
import LoadingOverlay from 'react-loading-overlay';


class App extends Component {

    handlePersistorState = () => {
        const { persistor } = this.props;
        let { bootstrapped } = persistor.getState();
        if (bootstrapped) {
            if (this.props.onBeforeLift) {
                Promise.resolve(this.props.onBeforeLift())
                    .then(() => this.setState({ bootstrapped: true }))
                    .catch(() => this.setState({ bootstrapped: true }));
            } else {
                this.setState({ bootstrapped: true });
            }
        }
    };

    componentDidMount() {
        this.handlePersistorState();
        window.addEventListener('resize', () => {
            CommonUtils.showLoaderScreen(false)
            console.log('window.:resize!!!!')
            // alert(1)
        });
    }

    render() {
        return (
            <Fragment>
                <Router history={history}>
                    <CustomScrollbars style={{ height: '100vh', width: '100vw' }}>
                        <div className="main-container">
                            <HeaderRegister />
                            <div className="content-container">
                                <Banner />
                                <div className="content-container-body">
                                    <Switch>
                                        <Route path={path.HOME} exact component={(Home)} />
                                        <Route path={path.ACCOUNT_REGISTER} component={CreateAccount} />
                                        <Route path={`${path.ACTIVE_EMAIL}`} component={ActiveEmail} />
                                    </Switch>
                                </div>
                                <FooterRegister />
                            </div>
                            <ToastContainer
                                className="toast-container" toastClassName="toast-item" bodyClassName="toast-item-body"
                                autoClose={false} hideProgressBar={true} pauseOnHover={false}
                                pauseOnFocusLoss={true} closeOnClick={false} draggable={false}
                                closeButton={<CustomToastCloseButton />}
                            />
                            <div id="loaderDiv" className="display_none">
                                <LoadingOverlay
                                    active={true}
                                    spinner={true}
                                >
                                </LoadingOverlay>
                            </div>
                        </div>
                    </CustomScrollbars>

                </Router>
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        started: state.app.started,
        isLoggedIn: state.admin.isLoggedIn
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
